import React, { createContext, useState, useCallback, } from 'react';
import { catchEditDeliveryInstructionsButtonPress } from '../utils/edit-delivery-instructions/analytics';
export var EditDeliveryInstructionsContext = createContext({
    deliveryInstructions: '',
    setDeliveryInstructions: function () { return ''; },
    editDeliveryInstructionsDrawerOpen: false,
    setEditDeliveryInstructionsDrawerOpen: function () { return null; },
    deliveryInstructionInfo: {},
    setDeliveryInstructionInfo: function () { return null; },
    handleEditDeliveryInstructions: function () { return null; },
    deliveryType: '',
    setDeliveryType: function () { return ''; },
    propertyTypesList: [],
    fulfillmentType: '',
    securityCode: '',
    setSecurityCode: function () { return ''; },
    lockboxLocation: '',
    setLockboxLocation: function () { return ''; },
    lockboxCode: '',
    setLockboxCode: function () { return ''; },
    preferredPackagePlacement: '',
    setPreferredPackagePlacement: function () { return ''; },
    propertyType: '',
    setPropertyType: function () { return ''; },
    siteConditions: '',
    setSiteConditions: function () { return ''; },
    additionalInstructions: '',
    setAdditionalInstructions: function () { return ''; },
    otherPropertyType: '',
    setOtherPropertyType: function () { return ''; },
    hasStairs: null,
    setHasStairs: function () { return null; },
    trucks36Foot: false,
    setTrucks36Foot: function () { return false; },
});
export var EditDeliveryInstructionsProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), deliveryInstructions = _b[0], setDeliveryInstructions = _b[1];
    var _c = useState(false), editDeliveryInstructionsDrawerOpen = _c[0], setEditDeliveryInstructionsDrawerOpen = _c[1];
    var _d = useState({}), deliveryInstructionInfo = _d[0], setDeliveryInstructionInfo = _d[1];
    var _e = useState(''), deliveryType = _e[0], setDeliveryType = _e[1];
    var propertyTypesList = [
        'House',
        'Apartment',
        'Business',
        'Construction Site',
        'Other',
    ];
    var _f = useState(''), securityCode = _f[0], setSecurityCode = _f[1];
    var _g = useState(''), lockboxLocation = _g[0], setLockboxLocation = _g[1];
    var _h = useState(''), lockboxCode = _h[0], setLockboxCode = _h[1];
    var _j = useState(''), preferredPackagePlacement = _j[0], setPreferredPackagePlacement = _j[1];
    var _k = useState(''), propertyType = _k[0], setPropertyType = _k[1];
    var _l = useState(''), siteConditions = _l[0], setSiteConditions = _l[1];
    var _m = useState(''), additionalInstructions = _m[0], setAdditionalInstructions = _m[1];
    var _o = useState(''), otherPropertyType = _o[0], setOtherPropertyType = _o[1];
    var _p = useState(null), hasStairs = _p[0], setHasStairs = _p[1];
    var _q = useState(false), trucks36Foot = _q[0], setTrucks36Foot = _q[1];
    var handleEditDeliveryInstructions = useCallback(function (instructionInfo) {
        setDeliveryInstructionInfo(instructionInfo);
        setEditDeliveryInstructionsDrawerOpen(true);
        catchEditDeliveryInstructionsButtonPress();
    }, []);
    return (React.createElement(EditDeliveryInstructionsContext.Provider, { value: {
            deliveryInstructions: deliveryInstructions,
            setDeliveryInstructions: setDeliveryInstructions,
            editDeliveryInstructionsDrawerOpen: editDeliveryInstructionsDrawerOpen,
            setEditDeliveryInstructionsDrawerOpen: setEditDeliveryInstructionsDrawerOpen,
            deliveryInstructionInfo: deliveryInstructionInfo,
            setDeliveryInstructionInfo: setDeliveryInstructionInfo,
            handleEditDeliveryInstructions: handleEditDeliveryInstructions,
            deliveryType: deliveryType,
            setDeliveryType: setDeliveryType,
            propertyTypesList: propertyTypesList,
            fulfillmentType: deliveryInstructionInfo.fulfillmentType || '',
            securityCode: securityCode,
            setSecurityCode: setSecurityCode,
            lockboxLocation: lockboxLocation,
            setLockboxLocation: setLockboxLocation,
            lockboxCode: lockboxCode,
            setLockboxCode: setLockboxCode,
            preferredPackagePlacement: preferredPackagePlacement,
            setPreferredPackagePlacement: setPreferredPackagePlacement,
            propertyType: propertyType,
            setPropertyType: setPropertyType,
            siteConditions: siteConditions,
            setSiteConditions: setSiteConditions,
            additionalInstructions: additionalInstructions,
            setAdditionalInstructions: setAdditionalInstructions,
            otherPropertyType: otherPropertyType,
            setOtherPropertyType: setOtherPropertyType,
            hasStairs: hasStairs,
            setHasStairs: setHasStairs,
            trucks36Foot: trucks36Foot,
            setTrucks36Foot: setTrucks36Foot,
        } }, children));
};
